import PubSub from 'pubsub-js'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'

import { get } from '@js/common/api'
import { getUrl } from '@js/common/getUrlByDomain'
import User from '@js/common/user'
import { getTestParam } from '@js/common/utils'

import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'
import CTA from '@f/elements/CTA'
const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

class SaleOfficesMap extends Component {
  markers = []

  state = {
    isMapLoaded: false
  }

  parser = new DOMParser()

  displayMarkers = () => {
    const bounds = new google.maps.LatLngBounds()

    this.markers.map(marker => {
      marker.setMap(null)
    })

    this.props.offices.map(office => {
      let position = new google.maps.LatLng(
        office.location.lat,
        office.location.lng
      )

      let icon = `<svg height="42" width="32" viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M14.971 39.71c-1.46-2.117-8.238-11.81-9.424-13.598-2.095-3.157-3.034-4.979-3.476-6.865-.229-.975-.321-1.962-.321-3.213 0-3.813 1.483-7.403 4.173-10.1A14.148 14.148 0 0 1 16 1.75c3.805 0 7.388 1.488 10.077 4.185a14.215 14.215 0 0 1 4.173 10.099c0 1.251-.092 2.238-.32 3.213-.443 1.886-1.382 3.708-3.477 6.865-1.186 1.788-7.966 11.483-9.424 13.598L16 41.202l-1.029-1.492z" stroke="${this.props.pinColours.fg}" stroke-width="2.5" fill="${this.props.pinColours.bg}" stroke-linejoin="round"/><path d="M9.579 12.611l5.833-3.45a1.153 1.153 0 0 1 1.176 0l5.833 3.45c.359.212.579.601.579 1.021v8.186C23 22.47 22.478 23 21.833 23h-4.265v-4.964h-3.2V23h-4.201C9.522 23 9 22.47 9 21.818v-8.186c0-.42.22-.809.579-1.02z" fill="${this.props.pinColours.fg}"/></g></svg>`

      this.markers.push(
        new google.maps.marker.AdvancedMarkerElement({
          position,
          map: this.map,
          content: this.parser.parseFromString(icon, 'image/svg+xml')
            .documentElement
        })
      )

      bounds.extend(position)
    })

    this.map.fitBounds(bounds)
  }

  handleReadyStateChange = event => {
    if (event.target.readyState === 'complete') {
      this.setState({ isMapLoaded: true })
    }
  }
  componentDidUpdate() {
    if (this.state.isMapLoaded && this.props?.offices?.length) {
      this.map = new google.maps.Map(this.saleOfficcesMapRef, {
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT
        },
        mapId: window.SherlockContainer?.environment?.GM_MAP_ID
      })

      this.displayMarkers()
    }
  }

  componentDidMount() {
    document.addEventListener('readystatechange', this.handleReadyStateChange)
  }

  componentWillUnmount() {
    document.removeEventListener(
      'readystatechange',
      this.handleReadyStateChange
    )
  }

  render() {
    return (
      <div
        ref={ref => (this.saleOfficcesMapRef = ref)}
        className='sale-offices-map'
      />
    )
  }
}

class SaleOffices extends Component {
  state = {
    offices: [],
    location: User.getLocation()
  }

  fetchSaleOffices = location => {
    if (location) {
      get(
        `sales-offices/?vendor_nid=${this.props.vendorNid}&display_delivery_regions__contains=${location.postcode}`
      ).then(data => {
        this.setState({
          offices: data.slice(0, 3),
          location: User.getLocation()
        })
      })
    }
  }

  receiveSuggestion = data => {
    if (data && data.postcode && data.country) {
      this.fetchSaleOffices({
        ...data,
        ...data.location
      })
    }
  }

  componentDidMount() {
    this.fetchSaleOffices(this.state.location)

    this.pbQueryupdate = PubSub.subscribe('QUERYUPDATE', (msg, data) => {
      this.fetchSaleOffices(data)
    })
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.pbQueryupdate)
  }

  render() {
    return (
      <>
        <p className='[ f-t-body f-c-fo-pri ] sale-offices-intro'>
          Geben Sie eine Postleitzahl ein, um Standorte in Ihrer Nähe zu finden
        </p>
        <LocationFinder
          onChange={this.receiveSuggestion}
          className='[ f-d-inbl ] VendorDetailPage-sale-office-search-wrapper'
          inputClassName='f-c-bo-neu025 VendorDetailPage-sale-office-search'
        />
        {this.state.offices.length > 0 && (
          <ul className='[ f-!list f-m-t-040 f-m-b-020 f-c-bo-neu025 ] sale-offices-results'>
            {this.state.offices.slice(0, 3).map(office => (
              <li
                key={`office-result-${office.nid}`}
                className='[ f-c-bo-neu025 f-t-body f-c-fo-pri f-p-v-020 ] sale-offices-result'>
                <CTA
                  type='text-primary'
                  tag='a'
                  className='[ f-t-body ] sale-offices-result-link'
                  href={
                    this.props.vendorNid !== office.vendor_nid &&
                    window.__DOMAIN__ === 'fertighaus' &&
                    office.vendor_slug
                      ? getUrl('vendorOffice')(office.vendor_slug, office.slug)
                      : getUrl('vendorOffice')(
                          this.props.vendorSlug,
                          office.slug
                        )
                  }>
                  Mehr erfahren
                </CTA>
                <span className='[ f-d-bl f-t-body f-c-fo-pri ]'>
                  {office.office_name}
                </span>
                {office.address_line_1 ? (
                  <span className='[ f-d-bl f-t-body f-c-fo-pri ]'>
                    {office.address_line_1}
                  </span>
                ) : null}
                {office.postal_code || office.city ? (
                  <span className='[ f-d-bl f-t-body f-c-fo-pri ]'>
                    {office.postal_code + ' ' + office.city}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        )}
        {/* Special request by HvH - hide the CTA on their VDP */}
        {this.props.vendorNid !== '1681c161' ? (
          <CTA
            type='text-primary'
            tag='a'
            className='[ f-t-body f-m-t-020 ] js-all-locations'
            href={getUrl('vendorOffices')(this.props.vendorSlug)}>
            Alle Standorte
          </CTA>
        ) : null}
        {this.props.showMap &&
          ReactDOM.createPortal(
            <SaleOfficesMap
              offices={this.state.offices}
              location={this.state.location}
              pinColours={this.props.pinColours}
            />,
            document.getElementById('sale-offices-map')
          )}
      </>
    )
  }
}

let saleOfficesNode = document.getElementById('sale-offices')
if (saleOfficesNode) {
  let pinColours = {}
  if (saleOfficesNode.dataset.pinColours) {
    try {
      pinColours = JSON.parse(saleOfficesNode.dataset.pinColours)
    } catch (e) {}
  }
  const root = createRoot(saleOfficesNode)
  root.render(
    <SaleOffices
      vendorNid={saleOfficesNode.dataset.vendorNid}
      vendorSlug={saleOfficesNode.dataset.vendorSlug}
      showMap={saleOfficesNode.dataset.hasOwnProperty('showMap')}
      pinColours={pinColours}
    />
  )
}
